import { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Users, Megaphone, PanelTop, BarChart3, LogOut, Zap, Menu, X
} from 'lucide-react';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/templates', icon: PanelTop, label: 'Templates' },
  { to: '/doctors', icon: Users, label: 'Doctors' },
  { to: '/campaigns', icon: Megaphone, label: 'Campaigns' },
  { to: '/stats', icon: BarChart3, label: 'Analytics' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dashboard-layout">
      {/* Hamburger Menu Button - Mobile Only (hidden when sidebar is open) */}
      {!sidebarOpen && (
        <button 
          className="hamburger-menu" 
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={24} />
        </button>
      )}

      {/* Sidebar Overlay - Mobile Only */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={closeSidebar}
        />
      )}

      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Close Button - Mobile Only */}
        <button 
          className="sidebar-close" 
          onClick={closeSidebar}
          aria-label="Close menu"
        >
          <X size={24} />
        </button>

        <div className="sidebar-logo">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <div style={{ width: 32, height: 32, background: 'rgba(255,255,255,0.15)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Zap size={16} color="white" />
            </div>
            <h2>QR Campaign</h2>
          </div>
          <span>Hilton Pharma System</span>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to} to={to} end={end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              onClick={closeSidebar}
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ padding: '10px 14px', marginBottom: 8 }}>
            <div style={{ color: 'white', fontSize: '0.875rem', fontWeight: 600 }}>{user?.name}</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}>{user?.role}</div>
          </div>
          <button className="nav-item" onClick={() => { handleLogout(); closeSidebar(); }} style={{ width: '100%', background: 'none', border: 'none' }}>
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content fade-in">
        <Outlet />
      </main>
    </div>
  );
}
